import { render, staticRenderFns } from "./reset-password-page.vue?vue&type=template&id=2f1c5a6e&scoped=true&"
import script from "./reset-password-page.vue?vue&type=script&lang=js&"
export * from "./reset-password-page.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-page.vue?vue&type=style&index=0&id=2f1c5a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c5a6e",
  null
  
)

export default component.exports